import dayjs from 'dayjs'

const opcoes = () =>
    [
        {
            label: 'DSR variável',
            value: '-1',
        },
    ].concat(
        Array.from({ length: 7 }).map((_, i) => ({
            value: i.toString(),
            label: dayjs().day(i).format('dddd'),
        })),
    )

export default opcoes
